import { CheckCircle2, AlertTriangle } from "lucide-react";
import { StatusBadge } from "@/components/app/common";
import { fmtDateTime } from "@/lib/format";

export function StatusHistoryTab({ order }) {
  return (
    <div data-testid="status-history-tab">
      <div className={`mb-4 text-xs flex items-center gap-2 ${order.history_consistent ? "text-emerald-700" : "text-red-700"}`} data-testid="status-consistency">
        {order.history_consistent ? <CheckCircle2 className="h-4 w-4" /> : <AlertTriangle className="h-4 w-4" />}
        {order.history_consistent ? "History matches current status" : "History does not match current status — contact admin"}
      </div>
      <ol className="relative border-l border-slate-200 ml-2">
        {order.status_history.map((h) => (
          <li key={h.id} className="ml-5 pb-5">
            <span className="absolute -left-1.5 h-3 w-3 rounded-full bg-sky-500 border-2 border-white" />
            <div className="flex items-center gap-2 flex-wrap">
              {h.from_status && <><StatusBadge status={h.from_status} /><span className="text-slate-400">→</span></>}
              <StatusBadge status={h.to_status} />
            </div>
            <div className="text-xs text-slate-500 mt-1">{h.by?.name} · {fmtDateTime(h.at)}{h.note ? ` — ${h.note}` : ""}</div>
          </li>
        ))}
      </ol>
      <h4 className="text-sm font-semibold mt-4 mb-2">Revisions ({(order.revisions || []).length})</h4>
      <div className="space-y-2" data-testid="order-revisions-list">
        {(order.revisions || []).map((r) => (
          <details key={r.id} className="border border-slate-200 rounded p-2 text-xs" data-testid={`order-revision-R${r.revision}`}>
            <summary className="cursor-pointer"><span className="font-mono font-semibold">R{r.revision}</span> · reopened from <span className="uppercase">{r.from_status.replace(/_/g, " ")}</span> by {r.by?.name} · {fmtDateTime(r.at)} — “{r.reason}”</summary>
            <div className="mt-2 text-slate-600">Value before change: <span className="font-mono">{r.header?.grand_total}</span></div>
            {r.lines.map((l) => <div key={l.id} className="font-mono text-slate-500">L{l.line_no} {l.description} · {l.qty} {l.uom} @ {l.unit_price}</div>)}
          </details>
        ))}
        {!(order.revisions || []).length && <p className="text-xs text-slate-500">No revisions. Approved orders are changed only through “Revise”, which keeps a copy of the earlier version.</p>}
      </div>
    </div>
  );
}
